// extracted by mini-css-extract-plugin
export default {"filterLabel":"style_filterLabel__FvDIw"};